import React from 'react'
import { withHandlers } from 'recompose'
import { change } from 'redux-form'

import ClearButton from './ClearButton'

const PickerWrapper = ({
  children, onClear, disabled,
}) => (
  <div className="picker-wrapper">
    {!disabled && <ClearButton onClick={onClear} />}
    {children}
  </div>
)

const EnhancePickerWrapper = withHandlers({
  onClear: ({ input: { onChange }, meta: { form, dispatch } }) => () => {
    dispatch(change(form, `objectId`, ``))
    dispatch(change(form, `object`, ``))
    onChange(``)
  },
})

export default EnhancePickerWrapper(PickerWrapper)
